import React from 'react';
import { Modal, Form } from 'react-bootstrap';
import { Card, Button, Input, Dropdown, DatePicker, Row, Checkbox, Table } from 'components';
import { parseHsppId, renderStatusColorClass } from 'services/helpers';
import moment from 'moment';
import { Link } from 'react-router-dom';
import ButtonBTN from 'react-bootstrap/Button';
import * as FileServer from 'file-saver';
import * as XLSX from 'xlsx';
import { FaSyncAlt } from 'react-icons/fa';

const Total = ({ _this }) => {
  const exportReport = () => {
    const extractedDataArray = [];
    for (const dataObject of _this.tableData) {
      const startSyclePatients = dataObject.startSyclePatients;
      const currentSyclePatients = dataObject.currentSyclePatients;
      const startActivePatients = dataObject.startActivePatients;
      const currentActivePatients = dataObject.currentActivePatients;
      const startActiveSubscriptions = dataObject.startActiveSubscriptions;
      const currentActiveSubscriptions = dataObject.currentActiveSubscriptions;
      const percHspp = dataObject.percHspp;
      const patientAdded = dataObject.patientAdded;
      const subscriptionAdded = dataObject.subscriptionAdded;

      const extractedData = {
        'Start Sycle Patients': startSyclePatients,
        'Current Sycle Patients': currentSyclePatients,
        'Start Active Patients': startActivePatients,
        'Current Active Patients': currentActivePatients,
        '% Hspp': percHspp,
        'Start Active Subscriptions': startActiveSubscriptions,
        'Current Active Subscriptions': currentActiveSubscriptions,
        'Patient Added': patientAdded,
        'Subscription Added': subscriptionAdded
      };

      extractedDataArray.push(extractedData);
    }
    const fileType =
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';

    const ws = XLSX.utils.json_to_sheet(extractedDataArray);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'data');

    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });

    // Create a Blob and save the Excel file
    const data = new Blob([excelBuffer], { type: fileType });
    FileServer.saveAs(data, 'ActiveHsppPatientReport' + fileExtension);
  };

  const columns = [
    {
      headerStyle: { fontSize: '90%' },
      Header: 'Start Sycle Patients',
      sortable: false,
      Cell: (row) => <div>{row.original.startSyclePatients}</div>
    },
    {
      sortable: false,
      headerStyle: { fontSize: '90%' },
      Header: 'Current Sycle Patinets',
      Cell: (row) => <div>{row.original.currentSyclePatients}</div>
    },
    {
      sortable: false,
      headerStyle: { fontSize: '90%' },
      Header: 'Start Active Patients',
      Cell: (row) => <div>{row.original.startActivePatients}</div>
    },
    {
      sortable: false,
      headerStyle: { fontSize: '90%' },
      Header: 'Current Active Patients',
      Cell: (row) => <div>{row.original.currentActivePatients}</div>
    },
    {
      sortable: false,
      accessor: 'percHspp',
      headerStyle: { fontSize: '90%' },
      Header: '% HSPP',
      Cell: (row) => <div>{row.original.percHspp}</div>
    },
    {
      sortable: false,
      accessor: 'startActiveSubscriptions',
      headerStyle: { fontSize: '90%' },
      Header: 'Start Active Subscriptions',
      Cell: (row) => <div>{row.original.startActiveSubscriptions}</div>
    },
    {
      sortable: false,
      accessor: 'currentActiveSubscriptions',
      headerStyle: { fontSize: '90%' },
      Header: 'Current Active Subscriptions',
      Cell: (row) => <div>{row.original.currentActiveSubscriptions}</div>
    },
    {
      sortable: false,
      headerStyle: { fontSize: '90%' },
      Header: 'Patient Added',
      accessor: 'patientAdded',
      Cell: (row) => <div>{row.original.patientAdded}</div>
    },
    {
      sortable: false,
      headerStyle: { fontSize: '90%' },
      Header: 'Subscription Added',
      accessor: 'subscriptionAdded',
      Cell: (row) => <div>{row.original.subscriptionAdded}</div>
    }
  ];

  return (
    <>
      {/* <Card background={'bg-cardbg1'}>
        <div className="flex flex-row justify-between">
          <h3 className="text-body-color text-xl md:text-2xl">Dropped Patients Reports</h3>
        </div>
      </Card> */}
      <Card className="flex mr-2 mt-2" paddingClass="px-1 py-2">
        <div className="flex gap-2">
          <ButtonBTN
            onClick={() => exportReport()}
            className={`bg-button-primary  mb-2`}
            variant="primary"
            id="export"
          >
            Export
          </ButtonBTN>
          <ButtonBTN
            onClick={() => _this.syncReport()}
            className={`bg-button-primary mb-2 ml-2 flex justify-between items-center`}
            variant="primary"
            id="export"
            disabled={_this.inSync}
          >
            Sync <FaSyncAlt className={`ml-1 ${_this.inSync ? 'animate-spin' : ''}`} />
          </ButtonBTN>
        </div>
        <Table
          keyField="_id"
          columns={columns}
          data={_this.tableData}
          headerComponent={null}
          pageSize={10}
        />
      </Card>
    </>
  );
};

export default Total;
